import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Observable } from 'rxjs';

import { DcIcons } from '../../../ui/app-dc.icons';

export enum ChartAction {
	Delete = 'delete',
}

export interface IChartActionModalData {
	chartId: number | Array<number>;
	element: string;
	action: ChartAction;
}

@Component({
	selector: 'app-chart-action-popup',
	templateUrl: './chart-action-popup.component.html',
	styleUrls: ['./chart-action-popup.component.scss'],
})
export class ChartActionPopupComponent<T extends IChartActionModalData>
	extends DcBaseComponent
	implements OnInit
{
	public vo$!: Observable<{
		element: string;
		chartId: number | Array<number>;
		isMultipleElement: boolean;
		action: ChartAction;
	}>;
	public confirmDeletion = false;

	protected readonly DcIcons = DcIcons;
	protected readonly ChartAction = ChartAction;
	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'chart-action';
	}

	public ngOnInit(): void {
		super.ngOnInit();
		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement:
				Array.isArray(this.modalData.chartId) && this.modalData.element === '',
			chartId: this.modalData.chartId,
			action: this.modalData.action,
		});
	}

	public confirmAction(): void {
		this.modalService.closeActiveModal({
			shouldLaunch: true,
		});
	}
}
